/** Mirrors PLP `Filter Applied` payload (via `buildFilterAppliedEventPayload`). */
export const HOME_PAGE_PLP_FILTER_APPLIED = 'Home Page PLP Filter Applied';
